import i18n from '@plugins/i18n';

import Collection from '@/models/Collection';
import BillingGroup from '@/models/BillingGroup';

export class BillingGroupCollection extends Collection {
    static type = 'BillingGroupCollection';
    static endpoint = BillingGroup.api.index;
    static model = BillingGroup;

    get default_headers() {
        return ['name', 'investors_count'];
    }

    get preset_sort_by() {
        return ['name:asc'];
    }

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                filterable: true,
                width: '18rem'
            }),
            this.createHeader('investors_count', i18n.t('_page.rate_plan.billing_group_members'), {
                width: '10rem'
            })
        ];
    }

    /**
     * Selector helper: billing groups for the given adviser.
     * @param {string} adviserId
     * @returns {object}
     */
    static selectorFilters(adviserId) {
        return {
            request_adviser_id: adviserId
        };
    }
}

export default BillingGroupCollection;
